import './financeExperience.css';
import { getPayrollSnapshot, payrollNet } from '../../../core/finance/payrollSnapshot';
export default function PayrollStubDrawer({
  shift,
  facilities,
  facilitiesById,
  usersByUid,
  onClose,
  cardStyle,
  buttonBaseStyle,
  fmtMoney,
  fmtHours,
  fmtDate,
  niceRole,
  roleKey,
  toMillis,
  getAssignedUid,
}) {
  if (!shift) return null;

  const s = shift;

  const snapshot = getPayrollSnapshot(s);
  const hrs = snapshot?.hours;

  const fid = String(
    s.facilityId || s.facilityID || s.facility || s.facilityProfileId || ""
  ).toLowerCase();

  const facilityProfile =
    facilitiesById.get(fid) ||
    facilitiesById.get(String(s.facilityId || "")) ||
    facilities.find((f) => String(f.id || "").toLowerCase() === fid) ||
    {};



  const rk = roleKey(
    s.role || s.requiredPosition || s.position || s.workerType || s.roleType
  );

  const rate = snapshot?.rate;
  const grossPay = snapshot?.gross;
  const deductions = Number(s.payrollDeductions || 0);
  const advances = Number(s.payrollAdvances || 0);
  const reimbursements = Number(s.payrollReimbursements || 0);
  const netPay = payrollNet(s, snapshot);

  const workerUid = getAssignedUid(s);
  const worker = usersByUid.get(workerUid)?.email || workerUid || "Unassigned";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,.35)",
        zIndex: 2000,
        display: "flex",
        justifyContent: "flex-end",
      }}
      onClick={onClose}
    >
      <div role="dialog" aria-modal="true" aria-label="Pay Stub" className="finance-drawer finance-workspace"
        style={{
          width: 460,
          maxWidth: "100%",
          height: "100vh",
          background: "#ffffff",
          padding: 18,
          overflowY: "auto",
          boxShadow: "-12px 0 30px rgba(15,23,42,.18)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 950, color: "#0f172a" }}>
              Pay Stub
            </div>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#64748b", marginTop: 4 }}>
              ShiftBridge Base Earnings - overtime excluded
            </div>
          </div>

          <button style={buttonBaseStyle()} onClick={onClose}>
            Close
          </button>
        </div>

        <div style={{ marginTop: 18, display: "grid", gap: 12 }}>
          <div style={{ ...cardStyle(), padding: 12 }}>
            <div style={{ fontWeight: 950, marginBottom: 8 }}>Worker</div>
            <div>{worker}</div>
            <div style={{ marginTop: 6, color: "#64748b", fontSize: 12 }}>
              UID: {workerUid || "—"}
            </div>
          </div>

          <div style={{ ...cardStyle(), padding: 12 }}>
            <div style={{ fontWeight: 950, marginBottom: 8 }}>Shift Details</div>
            <div>
              Facility: {facilityProfile?.name || facilityProfile?.facilityName || fid}
            </div>
            <div>Role: {niceRole(rk)}</div>
            <div>Date: {fmtDate(s.startTime)}</div>
            <div>Hours: {snapshot ? hrs.toFixed(4) : 'Review required'}</div>
            <div>Pay Rate: {snapshot ? fmtMoney(rate) : 'Unavailable'}/hr</div>
          </div>

          <div style={{ ...cardStyle(), padding: 12 }}>
            <div style={{ fontWeight: 950, marginBottom: 8 }}>Pay Summary</div>
            <div>Gross Pay: {snapshot ? fmtMoney(grossPay) : 'Review required'}</div>
            <div>Deductions: {fmtMoney(deductions)}</div>
            <div>Advances: {fmtMoney(advances)}</div>
            <div>Reimbursements: {fmtMoney(reimbursements)}</div>

            <div
              style={{
                marginTop: 10,
                paddingTop: 10,
                borderTop: "1px solid #e5e7eb",
                fontSize: 18,
                fontWeight: 950,
                color: "#166534",
              }}
            >
              Net Pay: {snapshot ? fmtMoney(netPay) : 'Review required'}
            </div>
          </div>

          <div style={{ ...cardStyle(), padding: 12 }}>
            <div style={{ fontWeight: 950, marginBottom: 8 }}>Payment Status</div>
            <div className="finance-pill">Status: {s.payrollPaidAt != null ? "Paid" : "Pending"}</div>
            <p className="finance-alert">{s.payrollReview?.required ? `Review required: ${String(s.payrollReview.reason).replace(/_/g, " ")}` : !snapshot ? "Review required: historical rate proof or a canonical snapshot is missing." : `Source: ${String(s.payrollProvenance?.rateSource || s.payrollProvenance?.kind || "verified snapshot").replace(/_/g, " ")}`}</p>
            <div>Paid At: {s.payrollPaidAt != null ? fmtDate(s.payrollPaidAt) : "—"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}